export function flightSaleCalculation({
  flightSaleAirlines,
  flightSaleGuests,
  flightSaleAddOns,
}) {
  let tempTotal: number = 0;
  tempTotal = flightSaleAirlines.reduce(
    (prev, curr) => prev + (curr.price || 0) * (flightSaleGuests || []).length,
    0,
  );
  tempTotal += flightSaleAddOns.reduce(
    (prev, curr) => prev + (curr.price || 0),
    0,
  );
  return tempTotal;
}

export function totalFlightSaleCalculation({
  flightSales,
  discount,
  otherCost,
}) {
  let tempTotal: number = 0;
  tempTotal = flightSales.reduce(
    (prev, curr) => prev + flightSaleCalculation(curr),
    0,
  );

  tempTotal -= discount || 0;
  tempTotal += otherCost || 0;
  return tempTotal;
}

export function flightRescheduleCalculation({ flightSales }) {
  return flightSales.reduce(
    (prev, curr) => prev + (curr.rescheduleFee || 0),
    0,
  );
}
